const settings = {
  secret: "@!@#RFQWLDFJOQJW$OJQWEFLFDKJASDLKVJslkdajflqjwpoefij2-3094789",
  passportSecret: "Kang Youngki"
};

export default settings;
